// Module
var code = "<div class=\"widget-content relative\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"> </wt-loading-panel> <div class=\"panel-group\"> <wt-variable-type-pane ng-repeat=\"viewModel in vm.nested\" view-model=\"viewModel\" is-expanded=\"vm.visibility[viewModel.key]\"> </wt-variable-type-pane> </div> </div>";
// Exports
module.exports = code;